<template>
  <svg v-if="canShowGantry()" :height="svgHeight" :width="CalculateSvgWidth" preserveAspectRatio="xMidYMid meet"
    style="display: flex; " :style="currentGantry?.hatchId == vesselProfileHatchId
      ? ''
      : 'visibility: hidden;'
      ">
    <!-- Gantry Crane -->
    <g>
      <g>
        <line x1="0" y1="40" :x2="CalculateSvgWidth" y2="40" stroke-width="4" :stroke="lineColor" />
        <image :href="this.currentGantry?.eqpExists
          ? 'media/vessels/CraneActive.png'
          : 'media/vessels/Crane.png'
          " x="0" y="0" width="40" height="40" />
        <text x="35" y="10" fill="#000" :font-size="fontSize" font-weight="bold">
          Code: {{ currentGantry?.code ?? "N/A" }}
        </text>
        <text v-if="showOpertaionType" x="35" y="25" fill="#000" :font-size="fontSize" font-weight="bold">
          Operation: {{ vesselMonitoringTypeText }}
        </text>
        <!-- Info Icon -->
        <g v-if="showInfo" :transform="`translate(${CalculateSvgWidth - 15}, 18)`" style="cursor: pointer" @click="showCraneDetails">
          <circle r="10" fill="#1976d2" />
          <text x="0" y="4" text-anchor="middle" :font-size="fontSize" fill="#fff" font-weight="bold">
            i
          </text>
        </g>

        <!-- Crane tower -->
        <!-- <rect x="0" y="40" width="18" height="120" fill="#616161"/> -->
        <!-- Crane boom -->
        <!-- <line x1="9" y1="40" x2="-100" y2="40" stroke="#424242" stroke-width="8"/> -->
        <!-- Trolley -->
        <!-- <rect x="-95" y="32" width="25" height="16" fill="#757575"/> -->
        <!-- Cable -->
        <!-- <line x1="-82" y1="48" x2="-82" :y2="containerY" stroke="#212121" stroke-width="3"/> -->
        <!-- Spreader -->
        <!-- <rect x="-92" :y="containerY" width="45" height="10" rx="2" fill="#424242"/> -->
        <!-- Lifted container -->
        <!-- <rect x="-100" :y="containerY + 10" width="55" height="30" fill="#1e88e5"/> -->
      </g>
    </g>
  </svg>
</template>

<script>
import HandlingQuayEquipmentDetailModal from "@/view/pages/vesselMonitoring/components/HandlingQuayEquipmentDetailModal.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    vesselBay: Object,
    CELL_WIDTH: { type: Number, default: 10 },
    SPACE_BETWEEN_CELLS: { type: Number, default: 10 },
    svgWidth: { type: Number, default: 10 },
    svgHeight: { type: Number, default: 45 },
    voyageId: { type: Number, default: 0 },
    vesselProfileHatchId: { type: Number, default: 0 },
    fontSize:{type:Number,default:10},
    showInfo:{type:Boolean,default:true},
    showOpertaionType:{type:Boolean,default:true}
  },
  data() {
    return {
      containerY: 120,
    };
  },
  mounted() {
    this.animateContainer();
  },
  methods: {
    ...mapActions([
      "setHandlingQuayEquipmentDetailRequest",
      "setIshandlingQuayEquipmentDetailModalOpen",
    ]),

    GetGantryCrane(bay) {
      let bays = Array.isArray(bay) ? bay : [bay];
      return (
        this.gantryCrane.filter((item) =>
          bays.some((b) => Number(item.currentBay) === Number(b))
        )[0] || null
      );
    },
    getBayX(bay) {
      return 50 + (bay - 1) * (this.CELL_WIDTH + this.SPACE_BETWEEN_CELLS);
    },
    animateContainer() {
      const targetY = 60;
      const step = 1;
      const interval = setInterval(() => {
        if (this.containerY > targetY) {
          this.containerY -= step;
        } else {
          clearInterval(interval);
        }
      }, 20);
    },
    showCraneDetails() {
      this.setHandlingQuayEquipmentDetailRequest({
        equipmentId: this.currentGantry?.equipmentId,
      });
      this.setIshandlingQuayEquipmentDetailModalOpen(true);
    },
    canShowGantry() {
      if (!this.currentGantry) return false;

      const type = Number(this.getvesselMonitoringType);
      const operation = Number(this.currentGantry.voyageOperationType);

      // Inventory → همه نمایش داده شوند
      if (type === 4) return true;
      console.log("type",type)
      console.log("operation",operation)
      // بقیه فقط در صورت برابر بودن
      return type === operation;
    },
  },
  computed: {
    ...mapGetters({
      gantryCrane: "gantryCrane",
      getvesselMonitoringType: "getvesselMonitoringType",
    }),
    vesselMonitoringTypeText() {
      const map = {
        1: "Discharge",
        2: "Load",
        3: "Restow",
        4: "Inventory",
      };
      return map[this.currentGantry?.voyageOperationType] || "N/A";
    },
    CalculateSvgWidth() {
      return this.svgWidth * this.CELL_WIDTH;
    },
    lineColor() {
      if (this.currentGantry?.eqpExists !== undefined) {
        return this.currentGantry?.eqpExists ? "#28a745" : "#e0e0e0";
      } else {
        return "#e0e0e0";
      }
    },

    currentGantry() {
      let bays = Array.isArray(this.vesselBay?.bays)
        ? this.vesselBay?.bays
        : [this.vesselBay?.bays];
      return (
        this.gantryCrane.filter((item) =>
          bays.some((b) => Number(item.currentBay) === Number(b) && item.eqpExists)
        )[0] || null
      );
    },
  },
};
</script>
